interface StateProvince {
  name: string;
  code: string;
  country: string;
}

// States for USA
const usaStates: StateProvince[] = [
  { name: 'Alabama', code: 'AL', country: 'USA' },
  { name: 'Alaska', code: 'AK', country: 'USA' },
  { name: 'Arizona', code: 'AZ', country: 'USA' },
  { name: 'Arkansas', code: 'AR', country: 'USA' },
  { name: 'California', code: 'CA', country: 'USA' },
  { name: 'Colorado', code: 'CO', country: 'USA' },
  { name: 'Connecticut', code: 'CT', country: 'USA' },
  { name: 'Delaware', code: 'DE', country: 'USA' },
  { name: 'Florida', code: 'FL', country: 'USA' },
  { name: 'Georgia', code: 'GA', country: 'USA' },
  { name: 'Hawaii', code: 'HI', country: 'USA' },
  { name: 'Idaho', code: 'ID', country: 'USA' },
  { name: 'Illinois', code: 'IL', country: 'USA' },
  { name: 'Indiana', code: 'IN', country: 'USA' },
  { name: 'Iowa', code: 'IA', country: 'USA' },
  { name: 'Kansas', code: 'KS', country: 'USA' },
  { name: 'Kentucky', code: 'KY', country: 'USA' },
  { name: 'Louisiana', code: 'LA', country: 'USA' },
  { name: 'Maine', code: 'ME', country: 'USA' },
  { name: 'Maryland', code: 'MD', country: 'USA' },
  { name: 'Massachusetts', code: 'MA', country: 'USA' },
  { name: 'Michigan', code: 'MI', country: 'USA' },
  { name: 'Minnesota', code: 'MN', country: 'USA' },
  { name: 'Mississippi', code: 'MS', country: 'USA' },
  { name: 'Missouri', code: 'MO', country: 'USA' },
  { name: 'Montana', code: 'MT', country: 'USA' },
  { name: 'Nebraska', code: 'NE', country: 'USA' },
  { name: 'Nevada', code: 'NV', country: 'USA' },
  { name: 'New Hampshire', code: 'NH', country: 'USA' },
  { name: 'New Jersey', code: 'NJ', country: 'USA' },
  { name: 'New Mexico', code: 'NM', country: 'USA' },
  { name: 'New York', code: 'NY', country: 'USA' },
  { name: 'North Carolina', code: 'NC', country: 'USA' },
  { name: 'North Dakota', code: 'ND', country: 'USA' },
  { name: 'Ohio', code: 'OH', country: 'USA' },
  { name: 'Oklahoma', code: 'OK', country: 'USA' },
  { name: 'Oregon', code: 'OR', country: 'USA' },
  { name: 'Pennsylvania', code: 'PA', country: 'USA' },
  { name: 'Rhode Island', code: 'RI', country: 'USA' },
  { name: 'South Carolina', code: 'SC', country: 'USA' },
  { name: 'South Dakota', code: 'SD', country: 'USA' },
  { name: 'Tennessee', code: 'TN', country: 'USA' },
  { name: 'Texas', code: 'TX', country: 'USA' },
  { name: 'Utah', code: 'UT', country: 'USA' },
  { name: 'Vermont', code: 'VT', country: 'USA' },
  { name: 'Virginia', code: 'VA', country: 'USA' },
  { name: 'Washington', code: 'WA', country: 'USA' },
  { name: 'West Virginia', code: 'WV', country: 'USA' },
  { name: 'Wisconsin', code: 'WI', country: 'USA' },
  { name: 'Wyoming', code: 'WY', country: 'USA' },
  { name: 'District of Columbia', code: 'DC', country: 'USA' },
];

// Provinces for Canada
const canadaProvinces: StateProvince[] = [
  { name: 'Alberta', code: 'AB', country: 'Canada' },
  { name: 'British Columbia', code: 'BC', country: 'Canada' },
  { name: 'Manitoba', code: 'MB', country: 'Canada' },
  { name: 'New Brunswick', code: 'NB', country: 'Canada' },
  { name: 'Newfoundland and Labrador', code: 'NL', country: 'Canada' },
  { name: 'Northwest Territories', code: 'NT', country: 'Canada' },
  { name: 'Nova Scotia', code: 'NS', country: 'Canada' },
  { name: 'Nunavut', code: 'NU', country: 'Canada' },
  { name: 'Ontario', code: 'ON', country: 'Canada' },
  { name: 'Prince Edward Island', code: 'PE', country: 'Canada' },
  { name: 'Quebec', code: 'QC', country: 'Canada' },
  { name: 'Saskatchewan', code: 'SK', country: 'Canada' },
  { name: 'Yukon', code: 'YT', country: 'Canada' },
];

export const STATE_PROVINCE_NAMES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  DC: 'District Of Columbia',
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland And Labrador',
  NT: 'Northwest Territories',
  NS: 'Nova Scotia',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
};

export const statesProvinces: StateProvince[] = [
  ...usaStates,
  ...canadaProvinces,
];

export const getStateNameByCode = (code: string): string => {
  const state = statesProvinces.find((state) => state.code === code);
  return state ? state.name : '';
};

export const getStateCodeByName = (name: string): string => {
  const state = statesProvinces.find((state) => state.name === name);
  return state ? state.code : '';
};

/**
 * TCX-476: the one search matcher for every state/province picker. Options are
 * `{ label: name, value: code }`; AntD's default searches only `value` (codes)
 * and `optionFilterProp="label"` only names, so each picker matched just one.
 * This matches the name (contains) OR the code (starts with), case-insensitive
 * and trimmed. Empty input matches everything. Typed for AntD's `filterOption`
 * (its `option` argument is optional).
 */
export const filterStateOption = (
  input: string,
  option?: { label?: unknown; value?: unknown },
): boolean => {
  const q = (input ?? '').trim().toLowerCase();
  if (!q) return true;
  if (!option) return false;
  const label =
    typeof option.label === 'string' ? option.label.toLowerCase() : '';
  const value =
    typeof option.value === 'string' ? option.value.toLowerCase() : '';
  return (
    (label !== '' && label.includes(q)) || (value !== '' && value.startsWith(q))
  );
};
